module.exports = __webpack_public_path__ + "img/mycelium-lrg.08bdadab.svg";